// import React, { useEffect, useState } from "react";
// import ExaminationSidebar from "../../components/sidebar/ExaminationSidebar";
// import ExaminationNavbar from "../../components/navbar/ExaminationNavbar.jsx";
// import "./teacherOverview.scss";
// import Widget from "../../components/widget/Widget";
// import LineCharts from "../../components/chart/LineChart";
// import ExaminationCard from "../../components/card/ExaminationCard.jsx";
// import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
// import StackedBarChart from "../../components/chart/StackedBarChart.jsx";
// import CustomPieChart from "../../components/chart/PieChart.jsx";
// import Select from "react-select";
// import { serverUrl } from "../../temp.js";
// import { monthNames } from "../../enum.js";

// const samplePieData = [
//     { name: "A1", value: 20 },
//     { name: "A+", value: 36 },
//     { name: "A", value: 42 },
//     { name: "B", value: 38 },
//     { name: "C", value: 25 },
//     { name: "Retry", value: 25 },
// ];

// const TeacherOverview = () => {
//     const centerId = localStorage.getItem("center_id") || 38;
//     const [token] = useState(true);
//     const [sidebarOpen, setSidebarOpen] = useState(localStorage.getItem("sidebar") || false);
//     const [selectedClassId, setSelectedClassId] = useState(() => {
//         const stored = localStorage.getItem("class-id");
//         return stored ? stored : "7";  // Default to class ID 7 if nothing stored
//     });

//     const idealGrades = ['A1', 'A', 'B', 'C', 'D', 'Retry'];
//     const idealColors = ['#00C49F', '#0088FE', '#FFBB28', '#FF8042', '#AF19FF', '#FF193D'];

//     // Dropdown states
//     const [selectedMonths, setSelectedMonths] = useState([]);
//     const [selectedSubjects, setSelectedSubjects] = useState([]);
//     const [selectedTeachers, setSelectedTeachers] = useState([]);
//     const [selectedStudents, setSelectedStudents] = useState([]);

//     // Options states
//     const [monthOptions, setMonthOptions] = useState([]);
//     const [subjectOptions, setSubjectOptions] = useState([]);
//     const [teacherOptions, setTeacherOptions] = useState([]);
//     const [studentOptions, setStudentOptions] = useState([]);

//     // Chart data states
//     const [lineChartData, setLineChartData] = useState([]);
//     const [pieChartData, setPieChartData] = useState([]);
//     const [stackedBarChartData, setStackedBarChartData] = useState([]);

//     // Chart data state
//     const [chartData, setChartData] = useState([]);

//     // Card data state
//     const [cardData, setCardData] = useState({
//         class_average: 0,
//         course_covered: 0,
//         teacher_attendance: 0,
//         targeted_course_covered: 0
//     });

//     // Chart data states
//         const [teacherAttendanceData, setTeacherAttendanceData] = useState([]);
//         const [loadingAttendance, setLoadingAttendance] = useState({
//             teachers: false
//         });

//     const [subjectBarChartData, setSubjectBarChartData] = useState([]);

//     // Loading states
//     const [loading, setLoading] = useState({
//         months: true,
//         subjects: true,
//         teachers: true,
//         students: true,
//         lineChart: true,
//         pieChart: true,
//         stackedBarChart: true
//     });

//     const redirectToLogin = () => {
//         alert("Please Login first then you can access this page...");
//         window.location.href = "/";
//     };

//     const toggleSidebar = () => {
//         setSidebarOpen(!sidebarOpen);
//         localStorage.setItem("sidebar", !sidebarOpen);
//     };

//     const handleClassChange = (newClassId) => {
//         setSelectedClassId(newClassId);
//         localStorage.setItem("class-id", newClassId);

//         // Reset filters when class changes
//         setSelectedMonths([]);
//         setSelectedSubjects([]);
//         setSelectedTeachers([]);
//         setSelectedStudents([]);
//     };

//     // Fetch month options
//     useEffect(() => {
//         fetch(`${serverUrl}/result_dashboard/month_dropdown?centerId=${centerId}&classId=${selectedClassId}`)
//             .then(response => response.json())
//             .then(data => {
//                 if (data.code === "200") {
//                     setMonthOptions(data.data.map(month => ({
//                         value: month.month,
//                         label: month.month_name
//                     })));
//                 }
//                 setLoading(prev => ({ ...prev, months: false }));
//             })
//             .catch(error => {
//                 console.error("Error fetching months:", error);
//                 setLoading(prev => ({ ...prev, months: false }));
//             });
//     }, []);

//     // Fetch subject options when class changes
//     useEffect(() => {
//         if (!selectedClassId) return;

//         setLoading(prev => ({ ...prev, subjects: true }));
//         fetch(`${serverUrl}/result_dashboard/subject_dropdown?centerId=${centerId}&classId=${selectedClassId}`)
//             .then(response => response.json())
//             .then(data => {
//                 if (data.code === "200") {
//                     setSubjectOptions(data.data.map(subject => ({
//                         value: subject.subject_id,
//                         label: subject.subject_name
//                     })));
//                 }
//                 setLoading(prev => ({ ...prev, subjects: false }));
//             })
//             .catch(error => {
//                 console.error("Error fetching subjects:", error);
//                 setLoading(prev => ({ ...prev, subjects: false }));
//             });
//     }, [selectedClassId]);

//     // // Fetch teacher options when subjects change
//     // useEffect(() => {
//     //     if (!selectedClassId) {
//     //         setTeacherOptions([]);
//     //         setSelectedTeachers([]);
//     //         return;
//     //     }

//     //     setLoading(prev => ({ ...prev, teachers: true }));
//     //     const subjectIds = selectedSubjects.map(sub => sub.value);

//     //     fetch(`${serverUrl}/result_dashboard/teacher_dropdown?centerId=${centerId}&classId=${selectedClassId}`, {
//     //         method: 'POST',
//     //         headers: {
//     //             'Content-Type': 'application/json'
//     //         },
//     //         body: JSON.stringify({ subjectId: subjectIds })
//     //     })
//     //         .then(response => response.json())
//     //         .then(data => {
//     //             if (data.code === "200") {
//     //                 setTeacherOptions(data.data.map(teacher => ({
//     //                     value: teacher.id,
//     //                     label: teacher.teacher_name
//     //                 })));
//     //             }
//     //             setLoading(prev => ({ ...prev, teachers: false }));
//     //         })
//     //         .catch(error => {
//     //             console.error("Error fetching teachers:", error);
//     //             setLoading(prev => ({ ...prev, teachers: false }));
//     //         });
//     // }, [selectedClassId, selectedSubjects]);

//     // Fetch teacher options when subjects change
//     useEffect(() => {
//         if (!selectedClassId) {
//             setTeacherOptions([]);
//             setSelectedTeachers([]);
//             return;
//         }

//         setLoading(prev => ({ ...prev, teachers: true }));
//         const subjectIds = selectedSubjects.map(sub => sub.value);

//         fetch(`${serverUrl}/result_dashboard/teacher_dropdown?centerId=${centerId}&classId=${selectedClassId}`, {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ subjectId: subjectIds })
//         })
//             .then(r => r.json())
//             .then(data => {
//                 if (data.code === "200") {
//                     const opts = data.data.map(t => ({ value: t.id, label: t.teacher_name }));
//                     setTeacherOptions(opts);

//                     if (opts.length) {
//                         setSelectedTeachers([opts[0]]);
//                         fetch(`${serverUrl}/result_dashboard/teacher-subjects?teacher_id=${opts[0].value}`)
//                             .then(res => res.json())
//                             .then(subData => {
//                                 if (subData.code === "200") {
//                                     const subOpts = subData.data.map(s => ({ value: s.subject_id, label: s.subject_name }));
//                                     setSubjectOptions(subOpts);
//                                     if (subOpts.length) setSelectedSubjects([subOpts[0]]);
//                                 }
//                             });
//                     }
//                 }
//             })
//             .finally(() => setLoading(prev => ({ ...prev, teachers: false })))
//             .catch(err => {
//                 console.error("Error fetching teachers:", err);
//                 setLoading(prev => ({ ...prev, teachers: false }));
//             });
//     }, [selectedClassId]);

//     useEffect(() => {
//         if (!selectedClassId) return;

//         setLoading(prev => ({ ...prev, chart: true }));
//         const monthIds = selectedMonths.map(m => m.value);
//         const subjectIds = selectedSubjects.map(s => s.value);

//         fetch(`${serverUrl}/result_dashboard/chart/class-average?centerId=${centerId}&classId=${selectedClassId}`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({
//                 monthids: monthIds,
//                 subjectids: subjectIds
//                 // Removed teacherids and studentids from the request
//             })
//         })
//             .then(response => response.json())
//             .then(data => {
//                 if (data.code === "200") {
//                     setChartData(data.data);
//                 }
//                 setLoading(prev => ({ ...prev, chart: false }));
//             })
//             .catch(error => {
//                 console.error("Error fetching chart data:", error);
//                 setLoading(prev => ({ ...prev, chart: false }));
//             });
//     }, [selectedClassId, selectedMonths, selectedSubjects]);

//     // Fetch card data when any filter changes
//     useEffect(() => {
//         if (!selectedClassId) return;

//         setLoading(prev => ({ ...prev, cards: true }));
//         const monthIds = selectedMonths.map(m => m.value);
//         const subjectIds = selectedSubjects.map(s => s.value);
//         const teacherIds = selectedTeachers.map(t => t.value);
//         const studentIds = selectedStudents.map(s => s.value);

//         fetch(`${serverUrl}/result_dashboard/home_card_data?centerId=${centerId}&classId=${selectedClassId}`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({
//                 months: monthIds,
//                 subjects: subjectIds,
//                 teachers: teacherIds,
//                 students: studentIds
//             })
//         })
//             .then(response => response.json())
//             .then(data => {
//                 if (data.code === "200") {
//                     setCardData(data.data);
//                 }
//                 setLoading(prev => ({ ...prev, cards: false }));
//             })
//             .catch(error => {
//                 console.error("Error fetching card data:", error);
//                 setLoading(prev => ({ ...prev, cards: false }));
//             });
//     }, [selectedClassId, selectedMonths, selectedSubjects, selectedTeachers, selectedStudents]);

//     // Fetch pie chart data
//     useEffect(() => {
//         if (!selectedClassId) return;

//         setLoading(prev => ({ ...prev, pieChart: true }));
//         const monthIds = selectedMonths.map(m => m.value);
//         const studentIds = selectedStudents.map(s => s.value);
//         const subjectids = selectedSubjects.map(s => s.value);

//         fetch(`${serverUrl}/result_dashboard/pie-chart?centerId=${centerId}&classId=${selectedClassId}`, {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({
//                 monthids: monthIds,
//                 studentids: studentIds,
//                 subjectids: subjectids,
//             })
//         })
//             .then(response => response.json())
//             .then(data => {
//                 // if (data.code === "200") {
//                 //     // Transform API data to pie chart format
//                 //     const transformedData = Object.entries(data.data).map(([name, value]) => ({
//                 //         name,
//                 //         value
//                 //     }));
//                 //     setPieChartData(transformedData);
//                 // }
//                 if (data.code === "200") {
//                     const transformedData = idealGrades.map((grade) => ({
//                         name: grade,
//                         value: data.data[grade] ?? 0  // Use 0 if grade is missing
//                     }));

//                     console.log("transformedData", transformedData);
//                     setPieChartData(transformedData);
//                 }
//                 setLoading(prev => ({ ...prev, pieChart: false }));
//             })
//             .catch(error => {
//                 console.error("Error fetching pie chart data:", error);
//                 setLoading(prev => ({ ...prev, pieChart: false }));
//             });
//     }, [selectedClassId, selectedMonths, selectedStudents, selectedSubjects]);

//     // Helper to format applied filters
//     const formatAppliedFilters = (filters) => {
//         return filters
//             .filter(filter => filter.value.length > 0)
//             .map(filter => ({
//                 label: filter.label,
//                 value: filter.value.map(v => v.label).join(', ')
//             }));
//     };

//     // Get applied filters for cards
//     const cardFilters = formatAppliedFilters([
//         { label: "Month", value: selectedMonths },
//         { label: "Subject", value: selectedSubjects },
//         { label: "Teacher", value: selectedTeachers },
//         { label: "Student", value: selectedStudents }
//     ]);

//     // Filters for pie charts
//     const pieFilters = formatAppliedFilters([
//         { label: "Month", value: selectedMonths },
//         { label: "Student", value: selectedStudents },
//         { label: "Subject", value: selectedSubjects }
//     ]);

//     // Get applied filters for chart (only month and subject)
//     const chartFilters = formatAppliedFilters([
//         { label: "Month", value: selectedMonths },
//         { label: "Subject", value: selectedSubjects }
//     ]);

//     // Fetch teacher attendance data
//         const fetchTeacherAttendance = () => {
//             setLoadingAttendance(prev => ({ ...prev, teachers: true }));
//             const teacherIds = selectedTeachers.map(t => t.value);
//             const months = selectedMonths.map(m => m.value);

//             fetch(`${serverUrl}/result_dashboard/teacher-attendance-monthly?centerId=${centerId}&classId=${selectedClassId}`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({
//                     months: months,
//                     teacherids: teacherIds
//                 })
//             })
//                 .then(response => response.json())
//                 .then(data => {
//                     if (data.code === "200") {
//                         setTeacherAttendanceData(data.data);
//                     }
//                     setLoadingAttendance(prev => ({ ...prev, teachers: false }));
//                 })
//                 .catch(error => {
//                     console.error("Error fetching teacher attendance:", error);
//                     setLoadingAttendance(prev => ({ ...prev, teachers: false }));
//                 });
//         };

//         // Transform attendance data for chart display
//         // const transformAttendanceData = (data, type) => {
//         //     // Get all unique months from the data
//         //     const monthSet = new Set();
//         //     data.forEach(item => {
//         //         Object.keys(item.attendanceByMonth).forEach(month => {
//         //             monthSet.add(month);
//         //         });
//         //     });
//         //     const months = Array.from(monthSet).sort();

//         //     // Create chart data structure
//         //     const chartData = data.map(item => {
//         //         let dataItem;
//         //         if(type === 'student'){
//         //             dataItem = {
//         //                 id: item[`${type}Id`],
//         //                 name: item[`commonName`]
//         //             };
//         //         }else{
//         //             dataItem = {
//         //                 id: item[`${type}Id`],
//         //                 name: item[`${type}Name`]
//         //             };
//         //         }

//         //         months.forEach(month => {
//         //             dataItem[month] = item.attendanceByMonth[month] || 0;
//         //         });

//         //         return dataItem;
//         //     });

//         //     return { chartData, months };
//         // };

//         const transformAttendanceData = (data, type) => {
//                 const monthSet = new Set();
//                 data.forEach(item => {
//                     Object.keys(item.attendanceByMonth).forEach(month => {
//                         monthSet.add(month); // e.g., "2025-06"
//                     });
//                 });

//                 const monthsRaw = Array.from(monthSet).sort(); // Keep chronological order
//                 const monthsFormatted = monthsRaw.map(m => {
//                     const [year, month] = m.split("-");
//                     return `${monthNames[parseInt(month, 10) - 1]} ${year}`;
//                 });

//                 const chartData = data.map(item => {
//                     let dataItem;
//                     if (type === 'student') {
//                         dataItem = { id: item[`${type}Id`], name: item[`commonName`] };
//                     } else {
//                         dataItem = { id: item[`${type}Id`], name: item[`${type}Name`] };
//                     }

//                     monthsRaw.forEach((month, idx) => {
//                         const label = monthsFormatted[idx];
//                         dataItem[label] = item.attendanceByMonth[month] || 0;
//                     });

//                     return dataItem;
//                 });

//                 return { chartData, months: monthsFormatted };
//             };

//         // // Format applied filters
//         // const formatAppliedFilters = (filters) => {
//         //     return filters
//         //         .filter(filter => filter.value.length > 0)
//         //         .map(filter => ({
//         //             label: filter.label,
//         //             value: filter.value.map(v => v.label).join(', ')
//         //         }));
//         // };

//         // Teacher attendance filters
//         const teacherAttendanceFilters = formatAppliedFilters([
//             { label: "Month", value: selectedMonths },
//             { label: "Teacher", value: selectedTeachers }
//         ]);

//         // Fetch data when filters change
//         useEffect(() => {
//             if (selectedClassId) {
//                 fetchTeacherAttendance();
//             }
//         }, [selectedClassId, selectedMonths, selectedTeachers]);

//         // Transform data for charts
//         const { chartData: teacherChartData, months: teacherMonths } = transformAttendanceData(teacherAttendanceData, 'teacher');

//     return (
//         <>
//             {!token && redirectToLogin()}
//             {token && (
//                 <div className="adminOverview">
//                     {sidebarOpen && (
//                         <ExaminationSidebar isOpen={sidebarOpen} toggle={toggleSidebar} />
//                     )}
//                     <div className="homeContainer">
//                         <ExaminationNavbar isOpen={sidebarOpen}
//                             toggle={toggleSidebar}
//                             selectedClassId={selectedClassId}
//                             onClassChange={handleClassChange} />
//                         <div className="heading">
//                             <h2>Teacher Overview</h2>
//                         </div>
//                         {/* <div className="widgets">
//                             <div className="dropdown-container">
//                                 <label htmlFor="dropdown1">Month</label>
//                                 <Select
//                                     id="dropdown1"
//                                     isMulti
//                                     options={monthOptions}
//                                     value={selectedMonths}
//                                     onChange={setSelectedMonths}
//                                     className="react-select-container"
//                                     classNamePrefix="react-select"
//                                 />
//                             </div>
//                             <div className="dropdown-container">
//                                 <label htmlFor="dropdown2">Subject</label>
//                                 <Select
//                                     id="dropdown2"
//                                     isMulti
//                                     options={subjectOptions}
//                                     value={selectedSubjects}
//                                     onChange={setSelectedSubjects}
//                                     className="react-select-container"
//                                     classNamePrefix="react-select"
//                                 />
//                             </div>
//                             <div className="dropdown-container">
//                                 <label htmlFor="dropdown3">Teacher</label>
//                                 <Select
//                                     id="dropdown3"
//                                     isMulti
//                                     options={teacherOptions}
//                                     value={selectedTeachers}
//                                     onChange={setSelectedTeachers}
//                                     className="react-select-container"
//                                     classNamePrefix="react-select"
//                                 />
//                             </div>
//                         </div> */}
//                         <div className="widgets">
//                             <div className="dropdown-container">
//                                 <label htmlFor="dropdown1">Month</label>
//                                 <Select
//                                     id="dropdown1"
//                                     isMulti
//                                     options={monthOptions}
//                                     value={selectedMonths}
//                                     onChange={setSelectedMonths}
//                                     isLoading={loading.months}
//                                     className="react-select-container"
//                                     classNamePrefix="react-select"
//                                 />
//                             </div>
//                             <div className="dropdown-container">
//                                 <label htmlFor="dropdown2">Subject</label>
//                                 <Select
//                                     id="dropdown2"
//                                     isMulti
//                                     options={subjectOptions}
//                                     value={selectedSubjects}
//                                     onChange={setSelectedSubjects}
//                                     isLoading={loading.subjects}
//                                     className="react-select-container"
//                                     classNamePrefix="react-select"
//                                 />
//                             </div>
//                             {/* <div className="dropdown-container">
//                                 <label htmlFor="dropdown3">Teacher</label>
//                                 <Select
//                                     id="dropdown3"
//                                     isMulti
//                                     options={teacherOptions}
//                                     value={selectedTeachers}
//                                     onChange={setSelectedTeachers}
//                                     isLoading={loading.teachers}
//                                     className="react-select-container"
//                                     classNamePrefix="react-select"
//                                 />
//                             </div> */}
//                             <div className="dropdown-container">
//                                 <label htmlFor="dropdown3">Teacher</label>
//                                 <Select
//                                     id="dropdown3"
//                                     options={teacherOptions}
//                                     value={selectedTeachers[0] || null}
//                                     onChange={selected => {
//                                         if (!selected) {
//                                             setSelectedTeachers([]);
//                                             return;
//                                         }
//                                         setSelectedTeachers([selected]);
//                                         fetch(`${serverUrl}/result_dashboard/teacher-subjects?teacher_id=${selected.value}`)
//                                             .then(res => res.json())
//                                             .then(subData => {
//                                                 if (subData.code === "200") {
//                                                     const subOpts = subData.data.map(s => ({ value: s.subject_id, label: s.subject_name }));
//                                                     setSubjectOptions(subOpts);
//                                                     if (subOpts.length) setSelectedSubjects([subOpts[0]]);
//                                                 }
//                                             });
//                                     }}
//                                     isLoading={loading.teachers}
//                                     className="react-select-container"
//                                     classNamePrefix="react-select"
//                                 />

//                             </div>
//                         </div>

//                         <div className="widgets">
//                             <ExaminationCard
//                                 type={"Teacher Attendance"}
//                                 value={`${parseFloat(cardData.teacher_attendance || 0).toFixed(2)}%`}
//                                 icon={<PersonOutlinedIcon />}
//                                 loading={loading.cards}
//                                 appliedFilters={cardFilters}
//                             />
//                             <ExaminationCard
//                                 type={"Class Average"}
//                                 value={`${parseFloat(cardData.class_average || 0).toFixed(2)}%`}
//                                 icon={<PersonOutlinedIcon />}
//                                 loading={loading.cards}
//                                 appliedFilters={cardFilters}
//                             />
//                             <ExaminationCard
//                                 type={"Targeted Course"}
//                                 value={`${parseFloat(cardData.targeted_course_covered || 0).toFixed(2)}%`}
//                                 icon={<PersonOutlinedIcon />}
//                                 loading={loading.cards}
//                                 appliedFilters={cardFilters}
//                             />
//                             <ExaminationCard
//                                 type={"Course Covered"}
//                                 value={`${parseFloat(cardData.course_covered || 0).toFixed(2)}%`}
//                                 icon={<PersonOutlinedIcon />}
//                                 loading={loading.cards}
//                                 appliedFilters={cardFilters}
//                             />
//                         </div>

//                         <div className="widgets">
//                             {/* <LineCharts title="Attendence Line Chart" /> */}
//                             <CustomPieChart
//                                 data={pieChartData}
//                                 colors={idealColors}
//                                 title="Grades"
//                                 loading={loading.pieChart}
//                                 appliedFilters={pieFilters}
//                             />
//                             <LineCharts title="Course Status" />
//                         </div>

//                         <div className="widgets">
//                             <StackedBarChart
//                                 title={"Teacher Attendance"}
//                                 data={teacherChartData}
//                                 subjectKeys={teacherMonths}
//                                 loading={loadingAttendance.teachers}
//                                 appliedFilters={teacherAttendanceFilters}
//                             />
//                             {/* <LineCharts title="Teacher Attendence (Line)" /> */}
//                             <LineCharts
//                                 title="Teacher Attendance (Line)"
//                                 data={teacherChartData.map(item => teacherMonths.map(month => item[month] || 0)).flat()}
//                                 labels={teacherMonths}
//                                 loading={loadingAttendance.teachers}
//                                 appliedFilters={teacherAttendanceFilters}
//                             />
//                         </div>

//                         <div className="widgets">
//                             <LineCharts
//                                 title={(selectedSubjects.length === 0) ? "Class Average" : "Subject Average"}
//                                 data={chartData.map(item => item.average_marks)}
//                                 labels={chartData.map(item => item.month_name)}
//                                 loading={loading.chart}
//                                 appliedFilters={chartFilters}
//                             />
//                         </div>

//                         <div className="charts">
//                             {/* <StackedBarChart title={"TA Attendence"} />
//                             <StackedBarChart title={"Course Status"} /> */}
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };

// export default TeacherOverview;

// src\pages\examination\TeacherOverview.jsx
import React, { useEffect, useState } from "react";
import ExaminationSidebar from "../../components/sidebar/ExaminationSidebar";
import ExaminationNavbar from "../../components/navbar/ExaminationNavbar.jsx";
import "./teacherOverview.scss";
import Widget from "../../components/widget/Widget";
import LineCharts from "../../components/chart/LineChart";
import ExaminationCard from "../../components/card/ExaminationCard.jsx";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import StackedBarChart from "../../components/chart/StackedBarChart.jsx";
import CustomPieChart from "../../components/chart/PieChart.jsx";
import Select from "react-select";
import { serverUrl } from "../../temp.js";
import { monthNames } from "../../enum.js";
import CourseProgressChart from "../../components/chart/CourseProgressChart.jsx";

const TeacherOverview = () => {
  const centerId = localStorage.getItem("center_id") || 38;
  const [token] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(
    localStorage.getItem("sidebar") || false
  );
  const [selectedClassId, setSelectedClassId] = useState(() => {
    const stored = localStorage.getItem("class-id");
    return stored ? stored : "7"; // Default to class ID 7 if nothing stored
  });

  const idealGrades = ["A1", "A", "B", "C", "D", "Retry"];
  const idealColors = [
    "#00C49F",
    "#0088FE",
    "#FFBB28",
    "#FF8042",
    "#AF19FF",
    "#FF193D",
  ];

  // Dropdown states
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);

  // Options states
  const [monthOptions, setMonthOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);
  const [teacherOptions, setTeacherOptions] = useState([]);
  const [studentOptions, setStudentOptions] = useState([]);

  // Chart data states
  const [lineChartData, setLineChartData] = useState([]);
  const [pieChartData, setPieChartData] = useState([]);
  const [stackedBarChartData, setStackedBarChartData] = useState([]);

  // Chart data state
  const [chartData, setChartData] = useState([]);

  // Card data state
  const [cardData, setCardData] = useState({
    class_average: 0,
    course_covered: 0,
    teacher_attendance: 0,
    targeted_course_covered: 0,
  });

  // Chart data states
  const [teacherAttendanceData, setTeacherAttendanceData] = useState([]);
  const [loadingAttendance, setLoadingAttendance] = useState({
    teachers: false,
  });

  const [subjectBarChartData, setSubjectBarChartData] = useState([]);

  // Course status data
  const [courseStatusData, setCourseStatusData] = useState([]);

  // Loading states
  const [loading, setLoading] = useState({
    months: true,
    subjects: true,
    teachers: true,
    students: true,
    lineChart: true,
    pieChart: true,
    stackedBarChart: true,
    cards: true,
    chart: true,
    courseStatus: true,
  });

  const redirectToLogin = () => {
    alert("Please Login first then you can access this page...");
    window.location.href = "/";
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    localStorage.setItem("sidebar", !sidebarOpen);
  };

  const handleClassChange = (newClassId) => {
    setSelectedClassId(newClassId);
    localStorage.setItem("class-id", newClassId);

    // Reset filters when class changes
    setSelectedMonths([]);
    setSelectedSubjects([]);
    setSelectedTeachers([]);
    setSelectedStudents([]);
  };

  // Fetch month options
  useEffect(() => {
    fetch(
      `${serverUrl}/result_dashboard/month_dropdown?centerId=${centerId}&classId=${selectedClassId}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          setMonthOptions(
            data.data.map((month) => ({
              value: month.month,
              label: month.month_name,
            }))
          );
        }
        setLoading((prev) => ({ ...prev, months: false }));
      })
      .catch((error) => {
        console.error("Error fetching months:", error);
        setLoading((prev) => ({ ...prev, months: false }));
      });
  }, [selectedClassId]);

  // Fetch subject options when class changes
  useEffect(() => {
    if (!selectedClassId) return;

    setLoading((prev) => ({ ...prev, subjects: true }));
    fetch(
      `${serverUrl}/result_dashboard/subject_dropdown?centerId=${centerId}&classId=${selectedClassId}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          setSubjectOptions(
            data.data.map((subject) => ({
              value: subject.subject_id,
              label: subject.subject_name,
            }))
          );
        }
        setLoading((prev) => ({ ...prev, subjects: false }));
      })
      .catch((error) => {
        console.error("Error fetching subjects:", error);
        setLoading((prev) => ({ ...prev, subjects: false }));
      });
  }, [selectedClassId]);

  // Fetch teacher options when subjects change
  useEffect(() => {
    if (!selectedClassId) {
      setTeacherOptions([]);
      setSelectedTeachers([]);
      return;
    }

    setLoading((prev) => ({ ...prev, teachers: true }));
    const subjectIds = selectedSubjects.map((sub) => sub.value);

    fetch(
      `${serverUrl}/result_dashboard/teacher_dropdown?centerId=${centerId}&classId=${selectedClassId}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ subjectId: subjectIds }),
      }
    )
      .then((r) => r.json())
      .then((data) => {
        if (data.code === "200") {
          const opts = data.data.map((t) => ({
            value: t.id,
            label: t.teacher_name,
          }));
          setTeacherOptions(opts);

          if (opts.length) {
            setSelectedTeachers([opts[0]]);
            fetch(
              `${serverUrl}/result_dashboard/teacher-subjects?teacher_id=${opts[0].value}`
            )
              .then((res) => res.json())
              .then((subData) => {
                if (subData.code === "200") {
                  const subOpts = subData.data.map((s) => ({
                    value: s.subject_id,
                    label: s.subject_name,
                  }));
                  setSubjectOptions(subOpts);
                  if (subOpts.length) setSelectedSubjects([subOpts[0]]);
                }
              });
          }
        }
      })
      .finally(() => setLoading((prev) => ({ ...prev, teachers: false })))
      .catch((err) => {
        console.error("Error fetching teachers:", err);
        setLoading((prev) => ({ ...prev, teachers: false }));
      });
  }, [selectedClassId]);

  useEffect(() => {
    if (!selectedClassId) return;

    setLoading((prev) => ({ ...prev, chart: true }));
    const monthIds = selectedMonths.map((m) => m.value);
    const subjectIds = selectedSubjects.map((s) => s.value);

    fetch(
      `${serverUrl}/result_dashboard/chart/class-average?centerId=${centerId}&classId=${selectedClassId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          monthids: monthIds,
          subjectids: subjectIds,
          // Removed teacherids and studentids from the request
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          setChartData(data.data);
        }
        setLoading((prev) => ({ ...prev, chart: false }));
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
        setLoading((prev) => ({ ...prev, chart: false }));
      });
  }, [selectedClassId, selectedMonths, selectedSubjects]);

  // Fetch card data when any filter changes
  useEffect(() => {
    if (!selectedClassId) return;

    setLoading((prev) => ({ ...prev, cards: true }));
    const monthIds = selectedMonths.map((m) => m.value);
    const subjectIds = selectedSubjects.map((s) => s.value);
    const teacherIds = selectedTeachers.map((t) => t.value);
    const studentIds = selectedStudents.map((s) => s.value);

    fetch(
      `${serverUrl}/result_dashboard/home_card_data?centerId=${centerId}&classId=${selectedClassId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          months: monthIds,
          subjects: subjectIds,
          teachers: teacherIds,
          students: studentIds,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          setCardData(data.data);
        }
        setLoading((prev) => ({ ...prev, cards: false }));
      })
      .catch((error) => {
        console.error("Error fetching card data:", error);
        setLoading((prev) => ({ ...prev, cards: false }));
      });
  }, [
    selectedClassId,
    selectedMonths,
    selectedSubjects,
    selectedTeachers,
    selectedStudents,
  ]);

  // Fetch pie chart data
  useEffect(() => {
    if (!selectedClassId) return;

    setLoading((prev) => ({ ...prev, pieChart: true }));
    const monthIds = selectedMonths.map((m) => m.value);
    const studentIds = selectedStudents.map((s) => s.value);
    const subjectids = selectedSubjects.map((s) => s.value);

    fetch(
      `${serverUrl}/result_dashboard/pie-chart?centerId=${centerId}&classId=${selectedClassId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          monthids: monthIds,
          studentids: studentIds,
          subjectids: subjectids,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        // if (data.code === "200") {
        //     // Transform API data to pie chart format
        //     const transformedData = Object.entries(data.data).map(([name, value]) => ({
        //         name,
        //         value
        //     }));
        //     setPieChartData(transformedData);
        // }
        if (data.code === "200") {
          const transformedData = idealGrades.map((grade) => ({
            name: grade,
            value: data.data[grade] ?? 0, // Use 0 if grade is missing
          }));

          console.log("transformedData", transformedData);
          setPieChartData(transformedData);
        }
        setLoading((prev) => ({ ...prev, pieChart: false }));
      })
      .catch((error) => {
        console.error("Error fetching pie chart data:", error);
        setLoading((prev) => ({ ...prev, pieChart: false }));
      });
  }, [selectedClassId, selectedMonths, selectedStudents, selectedSubjects]);

  // Fetch course status data
  useEffect(() => {
    if (!selectedClassId || selectedSubjects.length === 0) return;

    setLoading((prev) => ({ ...prev, courseStatus: true }));
    const subjectIds = selectedSubjects.map((s) => s.value);

    fetch(
      `${serverUrl}/result_dashboard/course-status-monthly?centerId=${centerId}&classId=${selectedClassId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          subjectId: subjectIds,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          setCourseStatusData(data.data);
        }
        setLoading((prev) => ({ ...prev, courseStatus: false }));
      })
      .catch((error) => {
        console.error("Error fetching course status data:", error);
        setLoading((prev) => ({ ...prev, courseStatus: false }));
      });
  }, [selectedClassId, selectedSubjects]);

  // Helper to format applied filters
  const formatAppliedFilters = (filters) => {
    return filters
      .filter((filter) => filter.value.length > 0)
      .map((filter) => ({
        label: filter.label,
        value: filter.value.map((v) => v.label).join(", "),
      }));
  };

  // Get applied filters for cards
  const cardFilters = formatAppliedFilters([
    { label: "Month", value: selectedMonths },
    { label: "Subject", value: selectedSubjects },
    { label: "Teacher", value: selectedTeachers },
    { label: "Student", value: selectedStudents },
  ]);

  // Filters for pie charts
  const pieFilters = formatAppliedFilters([
    { label: "Month", value: selectedMonths },
    { label: "Student", value: selectedStudents },
    { label: "Subject", value: selectedSubjects },
  ]);

  // Get applied filters for chart (only month and subject)
  const chartFilters = formatAppliedFilters([
    { label: "Month", value: selectedMonths },
    { label: "Subject", value: selectedSubjects },
  ]);

  // Filters for course status (subject only, since no month filter in API)
  const courseStatusFilters = formatAppliedFilters([
    { label: "Subject", value: selectedSubjects },
  ]);

  // Fetch teacher attendance data
  const fetchTeacherAttendance = () => {
    setLoadingAttendance((prev) => ({ ...prev, teachers: true }));
    const teacherIds = selectedTeachers.map((t) => t.value);
    const months = selectedMonths.map((m) => m.value);

    fetch(
      `${serverUrl}/result_dashboard/teacher-attendance-monthly?centerId=${centerId}&classId=${selectedClassId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          months: months,
          teacherids: teacherIds,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.code === "200") {
          setTeacherAttendanceData(data.data);
        }
        setLoadingAttendance((prev) => ({ ...prev, teachers: false }));
      })
      .catch((error) => {
        console.error("Error fetching teacher attendance:", error);
        setLoadingAttendance((prev) => ({ ...prev, teachers: false }));
      });
  };

  // Transform attendance data for chart display
  // const transformAttendanceData = (data, type) => {
  //     // Get all unique months from the data
  //     const monthSet = new Set();
  //     data.forEach(item => {
  //         Object.keys(item.attendanceByMonth).forEach(month => {
  //             monthSet.add(month);
  //         });
  //     });
  //     const months = Array.from(monthSet).sort();

  //     // Create chart data structure
  //     const chartData = data.map(item => {
  //         let dataItem;
  //         if(type === 'student'){
  //             dataItem = {
  //                 id: item[`${type}Id`],
  //                 name: item[`commonName`]
  //             };
  //         }else{
  //             dataItem = {
  //                 id: item[`${type}Id`],
  //                 name: item[`${type}Name`]
  //             };
  //         }

  //         months.forEach(month => {
  //             dataItem[month] = item.attendanceByMonth[month] || 0;
  //         });

  //         return dataItem;
  //     });

  //     return { chartData, months };
  // };

  const transformAttendanceData = (data, type) => {
    const monthSet = new Set();
    data.forEach((item) => {
      Object.keys(item.attendanceByMonth).forEach((month) => {
        monthSet.add(month); // e.g., "2025-06"
      });
    });

    const monthsRaw = Array.from(monthSet).sort(); // Keep chronological order
    const monthsFormatted = monthsRaw.map((m) => {
      const [year, month] = m.split("-");
      return `${monthNames[parseInt(month, 10) - 1]} ${year}`;
    });

    const chartData = data.map((item) => {
      let dataItem;
      if (type === "student") {
        dataItem = { id: item[`${type}Id`], name: item[`commonName`] };
      } else {
        dataItem = { id: item[`${type}Id`], name: item[`${type}Name`] };
      }

      monthsRaw.forEach((month, idx) => {
        const label = monthsFormatted[idx];
        dataItem[label] = item.attendanceByMonth[month] || 0;
      });

      return dataItem;
    });

    return { chartData, months: monthsFormatted };
  };

  // // Format applied filters
  // const formatAppliedFilters = (filters) => {
  //     return filters
  //         .filter(filter => filter.value.length > 0)
  //         .map(filter => ({
  //             label: filter.label,
  //             value: filter.value.map(v => v.label).join(', ')
  //         }));
  // };

  // Teacher attendance filters
  const teacherAttendanceFilters = formatAppliedFilters([
    { label: "Month", value: selectedMonths },
    { label: "Teacher", value: selectedTeachers },
  ]);

  // Fetch data when filters change
  useEffect(() => {
    if (selectedClassId) {
      fetchTeacherAttendance();
    }
  }, [selectedClassId, selectedMonths, selectedTeachers]);

  // Transform data for charts
  const { chartData: teacherChartData, months: teacherMonths } =
    transformAttendanceData(teacherAttendanceData, "teacher");

  return (
    <>
      {!token && redirectToLogin()}
      {token && (
        <div className="adminOverview">
          {sidebarOpen && (
            <ExaminationSidebar isOpen={sidebarOpen} toggle={toggleSidebar} />
          )}
          <div className="homeContainer">
            <ExaminationNavbar
              isOpen={sidebarOpen}
              toggle={toggleSidebar}
              selectedClassId={selectedClassId}
              onClassChange={handleClassChange}
            />
            <div className="heading">
              <h2>Teacher Overview</h2>
            </div>
            {/* <div className="widgets">
                            <div className="dropdown-container">
                                <label htmlFor="dropdown1">Month</label>
                                <Select
                                    id="dropdown1"
                                    isMulti
                                    options={monthOptions}
                                    value={selectedMonths}
                                    onChange={setSelectedMonths}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                />
                            </div>
                            <div className="dropdown-container">
                                <label htmlFor="dropdown2">Subject</label>
                                <Select
                                    id="dropdown2"
                                    isMulti
                                    options={subjectOptions}
                                    value={selectedSubjects}
                                    onChange={setSelectedSubjects}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                />
                            </div>
                            <div className="dropdown-container">
                                <label htmlFor="dropdown3">Teacher</label>
                                <Select
                                    id="dropdown3"
                                    isMulti
                                    options={teacherOptions}
                                    value={selectedTeachers}
                                    onChange={setSelectedTeachers}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                />
                            </div>
                        </div> */}
            <div className="widgets">
              <div className="dropdown-container">
                <label htmlFor="dropdown1">Month</label>
                <Select
                  id="dropdown1"
                  isMulti
                  options={monthOptions}
                  value={selectedMonths}
                  onChange={setSelectedMonths}
                  isLoading={loading.months}
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </div>
              <div className="dropdown-container">
                <label htmlFor="dropdown2">Subject</label>
                <Select
                  id="dropdown2"
                  isMulti
                  options={subjectOptions}
                  value={selectedSubjects}
                  onChange={setSelectedSubjects}
                  isLoading={loading.subjects}
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </div>
              {/* <div className="dropdown-container">
                                <label htmlFor="dropdown3">Teacher</label>
                                <Select
                                    id="dropdown3"
                                    isMulti
                                    options={teacherOptions}
                                    value={selectedTeachers}
                                    onChange={setSelectedTeachers}
                                    isLoading={loading.teachers}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                />
                            </div> */}
              <div className="dropdown-container">
                <label htmlFor="dropdown3">Teacher</label>
                <Select
                  id="dropdown3"
                  options={teacherOptions}
                  value={selectedTeachers[0] || null}
                  onChange={(selected) => {
                    if (!selected) {
                      setSelectedTeachers([]);
                      return;
                    }
                    setSelectedTeachers([selected]);
                    fetch(
                      `${serverUrl}/result_dashboard/teacher-subjects?teacher_id=${selected.value}`
                    )
                      .then((res) => res.json())
                      .then((subData) => {
                        if (subData.code === "200") {
                          const subOpts = subData.data.map((s) => ({
                            value: s.subject_id,
                            label: s.subject_name,
                          }));
                          setSubjectOptions(subOpts);
                          if (subOpts.length) setSelectedSubjects([subOpts[0]]);
                        }
                      });
                  }}
                  isLoading={loading.teachers}
                  className="react-select-container"
                  classNamePrefix="react-select"
                />
              </div>
            </div>

            <div className="widgets">
              <ExaminationCard
                type={"Teacher Attendance"}
                value={`${parseFloat(cardData.teacher_attendance || 0).toFixed(
                  2
                )}%`}
                icon={<PersonOutlinedIcon />}
                loading={loading.cards}
                appliedFilters={cardFilters}
              />
              <ExaminationCard
                type={"Class Average"}
                value={`${parseFloat(cardData.class_average || 0).toFixed(2)}%`}
                icon={<PersonOutlinedIcon />}
                loading={loading.cards}
                appliedFilters={cardFilters}
              />
              <ExaminationCard
                type={"Targeted Course"}
                value={`${parseFloat(
                  cardData.targeted_course_covered || 0
                ).toFixed(2)}%`}
                icon={<PersonOutlinedIcon />}
                loading={loading.cards}
                appliedFilters={cardFilters}
              />
              <ExaminationCard
                type={"Course Covered"}
                value={`${parseFloat(cardData.course_covered || 0).toFixed(
                  2
                )}%`}
                icon={<PersonOutlinedIcon />}
                loading={loading.cards}
                appliedFilters={cardFilters}
              />
            </div>

            <div className="widgets">
              {/* <LineCharts title="Attendence Line Chart" /> */}
              <CustomPieChart
                data={pieChartData}
                colors={idealColors}
                title="Grades"
                loading={loading.pieChart}
                appliedFilters={pieFilters}
              />
              <CourseProgressChart
                title="Course Status"
                data={courseStatusData}
                loading={loading.courseStatus}
                appliedFilters={courseStatusFilters}
              />
            </div>

            <div className="widgets">
              <StackedBarChart
                title={"Teacher Attendance"}
                data={teacherChartData}
                subjectKeys={teacherMonths}
                loading={loadingAttendance.teachers}
                appliedFilters={teacherAttendanceFilters}
              />
              {/* <LineCharts title="Teacher Attendence (Line)" /> */}
              <LineCharts
                title="Teacher Attendance (Line)"
                data={teacherChartData
                  .map((item) => teacherMonths.map((month) => item[month] || 0))
                  .flat()}
                labels={teacherMonths}
                loading={loadingAttendance.teachers}
                appliedFilters={teacherAttendanceFilters}
              />
            </div>

            <div className="widgets">
              <LineCharts
                title={
                  selectedSubjects.length === 0
                    ? "Class Average"
                    : "Subject Average"
                }
                data={chartData.map((item) => item.average_marks)}
                labels={chartData.map((item) => item.month_name)}
                loading={loading.chart}
                appliedFilters={chartFilters}
              />
            </div>

            <div className="charts">
              {/* <StackedBarChart title={"TA Attendence"} />
                            <StackedBarChart title={"Course Status"} /> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TeacherOverview;
